<template>
    <div class="flex gap-2 items-center text-xl font-semibold leading-7">
        <div
            class="leading-7"
            :class="isSale ? 'text-sale' : 'text-headline'"
        >
            {{ displayPrice }}*
        </div>

        <div class="text-placeholder-focus font-normal">
            {{ variantName }}
        </div>
    </div>

    <span
        v-if="price.specialPrice"
        class="text-sale text-base text-base-content leading-5"
    >
        {{ t('product.price.save') }} {{ formatPrice(discountPrice) }}* = {{ discountPercentage }}%
    </span>

    <span
        v-if="priceInfo"
        class="text-sale"
        v-html="priceInfo"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useCurrency } from '#imports'
import { useI18n } from 'vue-i18n'
import type { HblPrice } from '@/utils/types'

const { t } = useI18n()
const { formatPrice } = useCurrency()

const props = defineProps<{
    price: HblPrice,
    variantName?: string,
    priceInfo?: string,
    specialPrice?: string
}>()

const isSale = computed(() => !!props.price?.specialPrice || !!props.priceInfo)

const displayPrice = computed(() => props.specialPrice ?? formatPrice(Number(props.price?.regularPrice)))
const discountPrice = computed(() => Math.abs(Number(props.price?.discount ?? 0)))
const discountPercentage = computed(() => Math.round(Number(props.price?.percentage ?? 0)))
</script>
